import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ProjectService } from 'src/app/services/project.service';
import { UtilsService } from 'src/app/services/utils.service';
import { PopupConfigurationLayerComponent } from '../../configuration-layer/configuration-layer.component';
import { NgForm } from '@angular/forms';
import { ConfigurationLayerModel, ConfigurationModel } from 'src/app/models/configuration';
import { cloneDeep } from 'lodash';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'app-layers',
  templateUrl: './layers.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class LayersComponent implements OnInit {

  @ViewChild('ngForm') form!: NgForm;

  configurationController : ConfigurationService;
  selectedLayer: number = -1;

  constructor(configurationController : ConfigurationService,
    private projectService : ProjectService,
    private modalService: ModalControlService,
    private popupService : BsModalService,
    public bsModalRef: BsModalRef,
    private uiBlock: UiBlockService,
    private mapService: MapService) {
      this.configurationController = configurationController;
    }

  ngOnInit(): void {
    this.configurationController.saveChangesState();
  }

  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    this.cancelConfiguration(false); // escape key already hides the modal
  }

  cancelConfiguration(hideModal: boolean = true):void {
    this.configurationController.cancelConfigurationPopup();
    this.clearSelection();
    hideModal? this.bsModalRef.hide(): false;
  }

  clearSelection(): void{
    this.configurationController.currentConfiguration.layers.forEach(el => {
      el.isselected = false;
    });
  }

  async saveConfiguration():Promise<void> {
    if (!this.projectService.projectEditable()) {
      this.cancelConfiguration();
      return;
    }

    if (!(await this.configurationController.operationAllowedByCalculationManager())) {
      return;
    }

    this.uiBlock.startBlock("Saving configuration...");
    const config = ConfigurationModel.mapToService(this.configurationController.currentConfiguration);
    this.configurationController.saveConfiguration(config).subscribe(
      (data) => {
        const previousCurrentLayers: ConfigurationLayerModel[] = this.configurationController.currentConfiguration.clone().layers;
        const layersBeforeSave: ConfigurationLayerModel[] = cloneDeep(this.configurationController.tempConfiguration.layers);
        this.configurationController.currentConfiguration = ConfigurationModel.map(data);

        for (const layer of this.configurationController.currentConfiguration.layers) {
          const previousCurrentlayer: ConfigurationLayerModel = previousCurrentLayers
            .find((previousLayer: ConfigurationLayerModel) => previousLayer.id == layer.id)

          if (previousCurrentlayer) {
            layer.visible = previousCurrentlayer.visible;
          }

          const layerBeforeSave = layersBeforeSave.find(l => l.id == layer.id);

          const populateLayer: boolean = !layerBeforeSave || layerBeforeSave.path != layer.path || !layerBeforeSave.enabled;

          if (layer.type == 'GeoJsonLayer' && layer.enabled) {
            if (populateLayer) {
              this.mapService.populateGeoJsonLayer(layer);
            } else {
              layer.vectorLayer = previousCurrentlayer?.vectorLayer;
            }
          }
        }

        for (const layer of layersBeforeSave) {
          if (layer.enabled && !this.configurationController.currentConfiguration.layers.find(l => l.id == layer.id)?.enabled) {
            this.mapService.removeLayerFromMap(layer.id);
          }
        }
        this.uiBlock.stopBlock();
        this.modalService.showMesssageModal("Configuration saved", "Configuration was saved successfully!");
      }, (error) => {
        this.uiBlock.stopBlock();
        this.modalService.showMesssageModal("Error", "An error occurred on saving the configuration!");
      },
      () => {
        if (this.form != null) this.form.reset();
      })
    
    this.bsModalRef.hide();
  }

  selectLayer(i : number): void{
    if(i != this.selectedLayer){
      if(this.selectedLayer >= 0 && this.selectedLayer < this.configurationController.currentConfiguration.layers.length){
        this.configurationController.currentConfiguration.layers[this.selectedLayer].isselected = false;
      }
      this.selectedLayer = i;
      this.configurationController.currentConfiguration.layers[i].isselected = true;
    }
    else{
      var currentRow = this.selectedLayer;
      if(this.configurationController.currentConfiguration.layers[this.selectedLayer].isselected){
        this.selectedLayer = -1;
      }
      this.configurationController.currentConfiguration.layers[currentRow].isselected = !this.configurationController.currentConfiguration.layers[currentRow].isselected;
    }
  }

  selectedLayerEditable() {
    if (this.selectedLayer < 0 || this.selectedLayer >= this.configurationController.currentConfiguration.layers.length) { 
      return false;
    }

    return !this.configurationController.currentConfiguration.layers[this.selectedLayer].defaultLayer;
  }

  addLayer(): void{
    if(this.projectService.projectEditable()){
      const bsModalRef : BsModalRef = this.popupService.show(PopupConfigurationLayerComponent);
      //bsModalRef.content.layer = new ConfigurationLayerModel();
      bsModalRef.content.editMode = false;
      //bsModalRef.content.selectedRow = -1;
    }
  }

  editLayer(): void{
    if(this.projectService.projectEditable()){
      if(this.selectedLayer >= 0 && this.selectedLayer < this.configurationController.currentConfiguration.layers.length){
        const bsModalRef : BsModalRef = this.popupService.show(PopupConfigurationLayerComponent);
        bsModalRef.content.layer = this.configurationController.currentConfiguration.layers[this.selectedLayer];
        bsModalRef.content.editMode = true;
        bsModalRef.content.selectedRow = this.selectedLayer;
      }
      else{
        this.modalService.showMesssageModal("Configuration Layer", "You have to select 1 layer to edit.");
      }
    }
  }

  deleteLayer(): void{
    if(this.projectService.projectEditable()){
      if(this.selectedLayer >= 0 && this.selectedLayer < this.configurationController.currentConfiguration.layers.length){
        this.configurationController.currentConfiguration.layers.splice(this.selectedLayer,1);
      }
      else{
        this.modalService.showMesssageModal("Configuration Layer", "You have to select 1 layer to delete.");
      }
    }
  }

}
